import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { Grid, Typography, Card, CardContent, TextField, Button, MenuItem, Select, Backdrop, Tooltip, LinearProgress } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector, useDispatch } from "react-redux";
import { singleActivity } from "../redux/ActionCreator";
import { updateActivity } from "../redux/ActionCreator";
import Multiselect from 'multiselect-react-dropdown';
import CorouselImages from '../customComponents/carouselImages';
import config from '../config.json';
import { bulkUploadImagesToCloudinary } from "../functions/cloudinaryBulkUpload";
import { apiRequest } from "../functions/apiRequest";
import { handleFormChange } from "../functions/multiDropDown";
import { fetchAttributeValues, KeyFillDropDown } from "../functions/helpers/general";
import { useParams } from 'react-router-dom';
import DraggableImageGrid from '../customComponents/DraggableImageGrid';

const PREFIX = 'ActEdit';

const classes = {
  backdrop: `${PREFIX}-backdrop`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: "black",
  }
}));

const token = localStorage.getItem("token");

function ActEdit() {

  const  {id}  = useParams();
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const act = useSelector((state) => state.activity.activity);
  act.total_vol = act["vol_req"] ? act["vol_req"] : 0 + act["mother_vol"] ? act["mother_vol"] : 0;
  const [image, setImage] = useState(null);
  const [uniqueIdentifiers, setUniqueIdentifiers] = useState([])
  const [allUniqueIdentifierValues, setAllUniqueIdentifierValues] = useState([])
  const [selectedUniqueIdentifer, setSelectedUniqueIdentifer] = useState('');
  const [masterVolObj, setMasterVolObj] = useState({});
  const [masterRecObj, setMasterRecObj] = useState({});
  const [users, setUsers] = useState([]);
  const [imagesListFromDb, setImageslListFromDb] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedReceivers, setSelectedReceivers] = useState([]);
  const [isLoading, setisLoading] = useState(false)
  
  const [locations, setLocations] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [schools, setSchools] = useState([]);
  const [companies, setCompanies] = useState([]);

  // Initialization imagelist array
  let imagelist = [];

  const initialFormData = Object.freeze({
    title: "",
    description: "",
    start_date: "",
    end_date:"",
    est_hours: "",
    vol_req: "",
    mother_vol: "",
    what_donating: "",
    where_donating: "",
    category: "",
    location: "",
    end_date: "",
    whatsapp_link: "https://www.temporary-url.com/",
    fund_links: process.env.REACT_APP_HOST_NAME === 'giftoftime' ? `https://www.${process.env.REACT_APP_HOST_NAME}.in/donate` : `https://www.${process.env.REACT_APP_HOST_NAME}.com/donate`,
  });

  const [formData, updateFormData] = useState(initialFormData);

  const handleChange = (e) => {
    updateFormData({
      ...formData,
      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });
  };

  const handleImageChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setImage((prev) => (prev ? [...prev, ...filesArray] : filesArray));
  };

  const handleRemoveSelectedFile = (indexToRemove) => {
    setImage((prev) => (prev ? prev.filter((_, idx) => idx !== indexToRemove) : []));
  };

  const submit = async () => {
    let finallistimages;
    const body = {
      title: formData.title ? formData.title : act["title"],
      description: formData.description
        ? formData.description
        : act["description"],
      start_date: formData.start_date ? formData.start_date : act["start_date"],
      end_date: formData.end_date ? formData.end_date : act["end_date"],
      est_hours: formData.est_hours ? formData.est_hours : act["est_hours"],
      vol_req: formData.vol_req ? formData.vol_req : act["vol_req"],
      mother_vol: formData.mother_vol ? formData.mother_vol : act["mother_vol"],
      what_donating: formData.what_donating
        ? formData.what_donating
        : act["what_donating"],
      where_donating: formData.where_donating
        ? formData.where_donating
        : act["where_donating"],
      category: formData.category ? formData.category : act["category"],
      location: formData.location ? formData.location : act["location"],
      whatsapp_link: formData.whatsapp_link
        ? formData.whatsapp_link
        : act["whatsapp_link"],
      fund_links: formData.fund_links ? formData.fund_links : act["fund_links"],
      user: selectedUsers,
      receivers: selectedReceivers,
      receivers_count: formData.receivers_count ? formData.receivers_count : act["receivers_count"],
      school: formData.school ? formData.school : act["school"],
      community: formData.community ? formData.community : act["community"],
      company: formData.company ? formData.company : act["company"],
    };
    setisLoading(true)
    if (image && image.length > 0) {
      let imageArray = await bulkUploadImagesToCloudinary(image);
      const currentImages = (imagesListFromDb && imagesListFromDb.length > 0) ? imagesListFromDb : (act.image || []);
      finallistimages = currentImages.concat(imageArray);
      await apiRequest('put', JSON.stringify({ image: finallistimages }), `/act/pic/${id}`, token);
    };
    dispatch(updateActivity(token, id, body));
  }

  async function getActivityData() {
    const data = await apiRequest('get', null, `/events/eventid/list/view?event_id=${id}`);
    data[0].Volunteers.forEach((user) => {
      user['displayValue'] = user.first_name + " " + user.last_name;
    });
    data[0].Receivers.forEach((user) => {
      user['displayValue'] = user.first_name + " " + user.last_name;
    });
    setSelectedUsers(data[0].Volunteers)
    setSelectedReceivers(data[0].Receivers)
    for (let i = 0; i < data[0].Image.length; i++) {
      imagelist.push(data[0].Image[i]);
    }
    if (imagelist.length > 0) setImageslListFromDb(imagelist);
    return true;
  }

  const handleDeleteImageFromDb = async (urlToDelete) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;
    try {
      const response = await apiRequest(
        'delete',
        JSON.stringify({ image_urls: [urlToDelete] }),
        `/act/pic/${id}`,
        token,
        null,
        {},
        true
      );
      if (response && response.data && response.data.image) {
        setImageslListFromDb(response.data.image);
      } else {
        setImageslListFromDb((prev) => prev.filter((img) => img !== urlToDelete));
      }
    } catch (err) {
      console.error("Failed to delete image", err);
    }
  };

  useEffect(() => {
    async function fetchData() {
      await getUniqueIdentifiers();
      await getActivityData();
      dispatch(singleActivity(token, id));
    }
    fetchAttributeValues({ setLocations, setCommunities, setSchools, setCompanies, model: 'event' });
    fetchData();
    // eslint-disable-next-line
  }, []);

  async function getUniqueIdentifiers() {
    const response = await apiRequest('get', null, '/user/unique-identifiers/list', token, null, { maxBodyLength: Infinity }, true)
    setUniqueIdentifiers(response.data);
    return true;
  }

  const handleSearch = async (keyWord) => {
    if (keyWord.length > 3) {
      const response = await apiRequest('get', null, `/user/search/${keyWord}`, token, null, {}, true);
      response.data.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });
      setUsers(response.data);
    }
  }

  async function getValuesOfUniqueIdentifier(db_identifier) {
    try {
      setSelectedUniqueIdentifer(db_identifier);
      const response = await apiRequest('get', null, `/user/unique-identifiers/values/${db_identifier}`, token, false, { maxBodyLength: Infinity }, true);
      setAllUniqueIdentifierValues(response.data);
    } catch (err) {

    }
  }

  async function getUsersBasedOnUniqueIdentifier(existingUsers, value) {
    const response = await apiRequest('post', JSON.stringify({ value }), `/user/unique-identifiers/users/${selectedUniqueIdentifer}`, token, false, { maxBodyLength: Infinity }, true);
    response.data.forEach(user => {
      user.displayValue = user.first_name + " " + user.last_name;
    });
    let newSelectedUsers = Array.from(new Set([...existingUsers, ...response.data]))
    return { newSelectedUsers, valueUsers: response.data };
  }

  async function handleBulkAdditionOfUsers(selectedValue, type) {

    let value = selectedValue[selectedValue.length - 1].value;

    if (type === 'volunteer') {

      const { newSelectedUsers, valueUsers } = await getUsersBasedOnUniqueIdentifier(selectedUsers, value)

      masterVolObj[value] = valueUsers;
      onVolunteerSelect(newSelectedUsers)
      setMasterVolObj(masterVolObj)

    } else if (type === 'receiver') {

      const { newSelectedUsers, valueUsers } = await getUsersBasedOnUniqueIdentifier(selectedReceivers, value)

      masterRecObj[value] = valueUsers;
      onReceiverSelect(newSelectedUsers)
      setMasterRecObj(masterRecObj)

    }

  }

  async function removeSelected(values, type) {

    if (type === 'volunteer') {
      if (values.length === 0) {
        let newArr = [];
        let keyUsers = []
        for (let key of Object.keys(masterVolObj)) {
          keyUsers.push(...masterVolObj[key])
        }

        for (let selectedUser of selectedUsers) {
          let receiverPresent = keyUsers.some(receiver1 => receiver1.id === selectedUser.id)
          if (!receiverPresent) {
            newArr.push(selectedUser)
          }
        }

        onVolunteerSelect(newArr)
        return;
      }
      let newSelectedUsers = [];

      for (let selectedValue of values) {
        newSelectedUsers.push(...masterVolObj[selectedValue.value])
      }

      newSelectedUsers.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });

      onVolunteerSelect(newSelectedUsers)
    } else if (type === 'receiver') {
      if (values.length === 0) {
        let newArr = [];
        let keyUsers = []
        for (let key of Object.keys(masterRecObj)) {
          keyUsers.push(...masterRecObj[key])
        }

        for (let receiver of selectedReceivers) {
          let receiverPresent = keyUsers.some(receiver1 => receiver1.id === receiver.id)
          if (!receiverPresent) {
            newArr.push(receiver)
          }
        }

        onReceiverSelect(newArr)
        return;
      }
      let newSelectedReceivers = [];

      for (let selectedValue of values) {
        newSelectedReceivers.push(...masterRecObj[selectedValue.value])
      }

      newSelectedReceivers.forEach(user => {
        user.displayValue = user.first_name + " " + user.last_name;
      });

      onReceiverSelect(newSelectedReceivers)
    }

  }

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const onVolunteerSelect = (selectedItem) => {
    setSelectedUsers(selectedItem);
  }

  const onReceiverSelect = (selectedItem) => {
    setSelectedReceivers(selectedItem);
  }

  const deleteAct = () => {
    fetch(process.env.REACT_APP_API_URL + `/api/detail/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
      });
    setTimeout(() => {
      window.location.href = "/";
    }, 1500);
  };

  if (!isLoading) {
    return (
      <Grid container direction="row"
        alignItems="center"
        justifyContent="center" spacing={1} >
        < Grid item xs={11} md={8} >
          <Card
            variant="outlined"
            style={{
              marginTop: 20,
              backgroundColor: "#ffffff",
              zIndex: 10,
              borderRadius: 30,
            }}
          >
            <CardContent style={{}}>
              <Grid container spacing={3}>
                <Grid item xs={12} style={{ fontFamily: "Raleway" }}>
                  <Typography
                    component="h1"
                    style={{ fontSize: 35, fontFamily: "Raleway" }}
                  >
                    {act["founder_name"]}'s {act["title"]} <br></br> ( EDITING )
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    <strong>Title </strong>
                  </Typography>
                  <TextField
                    name="title"
                    id="title"
                    multiline
                    fullWidth
                    defaultValue={act["title"]}
                    onChange={handleChange}
                  ></TextField>
                </Grid>

                <Grid item xs={12}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    <strong> Description </strong>
                  </Typography>
                  <TextField
                    name="description"
                    id="description"
                    type="description"
                    multiline
                    fullWidth
                    defaultValue={act["description"]}
                    onChange={handleChange}
                  ></TextField>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> Start Date</strong>
                  </Typography>
                  <TextField
                    id="start_date"
                    name="start_date"
                    type="date"
                    size="small"
                    variant="outlined"
                    value={act["start_date"]}
                    defaultValue={act["start_date"]}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> End Date</strong>
                  </Typography>
                  <TextField
                    id="end_date"
                    name="end_date"
                    type="date"
                    size="small"
                    variant="outlined"
                    value={act["end_date"]}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> Category ( {act["category"]} ) </strong>
                  </Typography>
                  <Select
                    labelId="demo-simple-select-label"
                    id="category"
                    name="category"
                    style={{ width: 250 }}
                    value={act["category"] ? act["category"] : ""}
                    onChange={handleChange}
                  >
                    <MenuItem value={"Life Cred$"}>Life Cred$</MenuItem>
                    <MenuItem value={"Social Cred$"}>Social Cred$</MenuItem>
                    <MenuItem value={"Learning Cred$"}>Learning Cred$</MenuItem>
                    <MenuItem value={"Human Cred$"}>Human Cred$</MenuItem>
                    <MenuItem value={"Food Cred$"}>Food Cred$</MenuItem>
                    <MenuItem value={"Kid Cred$"}>Kid Cred$</MenuItem>
                    <MenuItem value={"Water Cred$"}>Water Cred$</MenuItem>
                    <MenuItem value={"Green Cred$"}>Green Cred$</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography className={classes.paper}>
                    Estimated Hours{" "}
                  </Typography>
                  <TextField
                    variant="outlined"
                    required
                    id="est_hours"
                    size="small"
                    name="est_hours"
                    type="number"
                    defaultValue={act["est_hours"] ? act["est_hours"] : 0}
                    inputProps={{ min: 0 }}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={6} md={6} style={{}}>
                  <Typography>
                    {" "}
                    Maximum Volunteers {" "}
                  </Typography>
                  <TextField
                    name="vol_req"
                    type="number"
                    defaultValue={act["total_vol"]}
                    variant="outlined"
                    value={act["vol_req"] + act["mother_vol"]}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  ></TextField>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Typography>
                    {" "}
                    Maximum Receivers {" "}
                  </Typography>
                  <TextField
                    name="receivers_count"
                    type="number"
                    value={act["receivers_count"] ? act["receivers_count"] : 0}
                    variant="outlined"
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  ></TextField>
                </Grid>

                <Grid item xs={12} md={12} style={{ fontFamily: "Raleway" }}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> Location</strong>
                  </Typography>
                  <KeyFillDropDown
                    options={locations}
                    keyName="location"
                    formData={act}
                    defaultValue={act["location"]}
                    updateFormData={updateFormData}
                    handleFormChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} md={12} style={{ fontFamily: "Raleway" }}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> Community</strong>
                  </Typography>
                  <KeyFillDropDown
                    options={communities}
                    keyName="community"
                    formData={act}
                    updateFormData={updateFormData}
                    handleFormChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} md={12} style={{ fontFamily: "Raleway" }}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> School </strong>
                  </Typography>
                  <KeyFillDropDown
                    options={schools}
                    keyName="school"
                    formData={act}
                    updateFormData={updateFormData}
                    handleFormChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12} md={12} style={{ fontFamily: "Raleway" }}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> Company</strong>
                  </Typography>
                  <KeyFillDropDown
                    options={companies}
                    keyName="company"
                    formData={act}
                    updateFormData={updateFormData}
                    handleFormChange={handleFormChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong>  What are you donating</strong>
                  </Typography>
                  <TextField
                    name="what_donating"
                    defaultValue={act["what_donating"]}
                    multiline
                    fullWidth
                    onChange={handleChange}
                  ></TextField>
                </Grid>
                <Grid item xs={12}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    <strong> Where is the event taking place </strong>
                  </Typography>
                  <TextField
                    name="where_donating"
                    defaultValue={act["where_donating"]}
                    multiline
                    fullWidth
                    onChange={handleChange}
                  ></TextField>
                </Grid>

                <Grid container spacing={3} style={{ padding: '15px' }}>
                  <Grid item xs={12} md={12}>
                    <Typography className={classes.paper}>
                      Unique Identifier Type for Volunteers/Receivers
                      <Tooltip
                        style={{ fontSize: 30 }}
                        title="Unique Identifier for Volunteers/Receivers"
                        arrow
                      >
                        <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                      </Tooltip>
                    </Typography>
                    <Select
                      labelId="demo-simple-select-label"
                      size="small"
                      defaultValue={""}
                      onChange={(e) => { getValuesOfUniqueIdentifier(e.target.value) }}
                      fullWidth
                    >
                      {uniqueIdentifiers.map(identifier =>
                        <MenuItem value={identifier.db_identifier} key={identifier.db_identifier}>
                          {identifier.name}
                        </MenuItem>
                      )}
                    </Select>
                  </Grid>
                  <Grid item md={8} xs={12}>
                    <Typography className={classes.paper}>
                      Choose Volunteers
                      <Tooltip
                        style={{ fontSize: 30 }}
                        title="Choose volunteers from dropdown list"
                        arrow
                      >
                        <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                      </Tooltip>
                    </Typography>

                    <Multiselect
                      options={users} // Options to display in the dropdown
                      onSelect={onVolunteerSelect} // Function will trigger on select event
                      selectedValues={selectedUsers}
                      onSearch={(e) => { handleSearch(e) }}
                      placeholder="Search by name/community"
                      displayValue="displayValue" // Property name to display in the dropdown options
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <Typography className={classes.paper}>
                      Choose Unique Identifier Name for Volunteers
                      <Tooltip
                        style={{ fontSize: 30 }}
                        title="Unique identifier to select all users of that group"
                        arrow
                      >
                        <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                      </Tooltip>
                    </Typography>

                    <Multiselect
                      options={allUniqueIdentifierValues} // Options to display in the dropdown
                      onSelect={(e) => { handleBulkAdditionOfUsers(e, 'volunteer') }} // Function will trigger on select event
                      displayValue="value"// Property name to display in the dropdown options
                      onRemove={(e) => { removeSelected(e, 'volunteer') }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ padding: '15px' }}>
                  <Grid item md={8} xs={12}>
                    <Typography className={classes.paper}>
                      Choose Receivers
                      <Tooltip
                        style={{ fontSize: 30 }}
                        title="Choose Receivers"
                        arrow
                      >
                        <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                      </Tooltip>
                    </Typography>

                    <Multiselect
                      options={users} // Options to display in the dropdown
                      onSelect={onReceiverSelect} // Function will trigger on select event
                      selectedValues={selectedReceivers}
                      displayValue="displayValue" // Property name to display in the dropdown options
                      onSearch={(e) => { handleSearch(e) }}
                      placeholder="Search by name/community"
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography className={classes.paper}>
                      Choose Unique Identifier Name for Receivers
                      <Tooltip
                        style={{ fontSize: 30 }}
                        title="Choose Receivers"
                        arrow
                      >
                        <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                      </Tooltip>
                    </Typography>

                    <Multiselect
                      options={allUniqueIdentifierValues} // Options to display in the dropdown
                      onSelect={(e) => { handleBulkAdditionOfUsers(e, 'receiver') }} // Function will trigger on select event
                      displayValue="value"// Property name to display in the dropdown options
                      onRemove={(e) => { removeSelected(e, 'receiver') }}
                    />
                  </Grid>

                </Grid>


                <Grid item md={12} xs={12}>
                  <Typography className={classes.paper}>
                    Enter your donation link(s) below:{" "}
                  </Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    size="small"
                    name="fund_links"
                    onChange={handleChange}
                  />
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    Enter your whatsapp group invite link below (optional) : (Only visible to members of the program once they have been accepted)
                  </Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    size="small"
                    name="whatsapp_link"
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8, marginTop: 10 }}>
                    Event Images
                  </Typography>
                  <input
                    type="file"
                    id="image"
                    accept="image/png, image/jpeg, image/jpg"
                    multiple
                    onChange={handleImageChange}
                    style={{ border: "none", outline: "none", cursor: "pointer" }}
                  />

                  {imagesListFromDb && imagesListFromDb.length > 0 && (
                    <DraggableImageGrid
                      items={imagesListFromDb}
                      onReorder={(newOrder) => setImageslListFromDb(newOrder)}
                      onDelete={(idx, url) => handleDeleteImageFromDb(url)}
                    />
                  )}

                  {image && image.length > 0 && (
                    <DraggableImageGrid
                      items={image}
                      onReorder={(newFiles) => setImage(newFiles)}
                      onDelete={(idx) => handleRemoveSelectedFile(idx)}
                    />
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Button
                    onClick={() => {
                      submit();
                    }}
                    style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor, color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor }}
                  >
                    make changes
                  </Button>{" "}
                  &nbsp;
                  <Button
                    onClick={handleToggle}
                    style={{ backgroundColor: "red", color: "white" }}
                  >
                    <DeleteIcon />{" "}
                  </Button>
                </Grid>

                <Backdrop
                  className={classes.backdrop}
                  open={open}
                  onClick={handleClose}
                  style={{ textAlign: "center", fontSize: 30 }}
                >
                  <Grid
                    container
                    style={{ backgroundColor: "white", borderRadius: 30 }}
                  >
                    <Grid item xs={12}>
                      Are you sure you want to delete
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        onClick={() => {
                          deleteAct();
                        }}
                      >
                        Yes
                      </Button>
                      <Button>No</Button>
                    </Grid>
                  </Grid>
                </Backdrop>
              </Grid>
            </CardContent>
          </Card>
        </Grid >

      </Grid >
    );
  } else {
    return (
      <Root style={{ marginTop: 20, textAlign: "center" }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </Root>
    );
  }
}

export default ActEdit;
